export enum CLOUD_FW_UPGRADE_STATE {
    CLOUD_FW_UPGRADE_STATE_UNKNOWN = -1,
    CLOUD_FW_UPGRADE_STATE_READY = 0,
    CLOUD_FW_UPGRADE_STATE_STARTED = 1,
    CLOUD_FW_UPGRADE_STATE_UPDATING = 2,
    CLOUD_FW_UPGRADE_STATE_FAILED_INIT = 3,
    CLOUD_FW_UPGRADE_STATE_FAILED_TIMEOUT = 4,
    CLOUD_FW_UPGRADE_STATE_FAILED_NOTUPDATED = 5,
    CLOUD_FW_UPGRADE_STATE_FAILED_NOTUPDATABLE = 6 // 20220513
}
